import { API_CONFIG } from '../config/api';
import { getToken } from './tokenStore';

const BASE = API_CONFIG.discoveryServiceURL;

async function discoverFetch(path) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `HTTP ${res.status}`);
  }
  return res.json();
}

/** @returns {Promise<Array<{id:string,name:string,...}>>} */
export async function listClusters(projectId) {
  if (projectId) {
    return discoverFetch(`/projects/${encodeURIComponent(projectId)}/clusters`);
  }
  return discoverFetch('/clusters/configs');
}

/**
 * @param {string} projectId
 * @param {string} clusterId
 * @returns {Promise<Array<{id:string,name:string,status:string,labels:object,...}>>}
 */
export async function listNamespaces(projectId, clusterId) {
  if (projectId) {
    return discoverFetch(`/projects/${encodeURIComponent(projectId)}/clusters/${encodeURIComponent(clusterId)}/namespaces`);
  }
  return discoverFetch(`/clusters/${encodeURIComponent(clusterId)}/namespaces`);
}

/**
 * @param {string} projectId
 * @param {string} clusterId
 * @param {string} namespace
 * @returns {Promise<{namespace:{id,name,status,labels,...}, pods:Array, services:Array, deployments:Array}>}
 */
export async function getNamespaceDetails(projectId, clusterId, namespace) {
  if (projectId) {
    return discoverFetch(
      `/projects/${encodeURIComponent(projectId)}/clusters/${encodeURIComponent(clusterId)}/namespaces/${encodeURIComponent(namespace)}`
    );
  }
  return discoverFetch(
    `/clusters/${encodeURIComponent(clusterId)}/namespaces/${encodeURIComponent(namespace)}`
  );
}
